import Audio from '../../elements/modal/playerLanguageModalAudio';
import Container from '../../atoms/container/playerLanguageModalContainer';
import Focus from '../../../../shared/types/enums/focus';
import Icon from '../../elements/modal/playerLanguageModalIcon';
import Subtitles from '../../elements/modal/playerLanguageModalSubtitles';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import {
  channelDown,
  channelUp,
} from '../../../../shared/store/thunks/channels.thunk';
import { clearModal } from '../../../../shared/store/slices/modal.slice';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { useEffect, useRef } from 'react';
import {
  filterFocus,
  selectFocus,
  popFocus,
  pushFocus,
} from '../../../../shared/store/slices/focus.slice';

function PlayerLanguageModal() {
  const dispatch = useAppDispatch();
  const focus = useAppSelector(selectFocus);

  const focusRef = useRef(focus);
  focusRef.current = focus;

  // Keyboard hooks

  useKeyboard({
    canBeFocused: false,
    stopPropagation: true,
    keyDownHandler: (key) => {
      switch (key) {
        case 'CHANNEL_UP':
          dispatch(channelUp());
          break;
        case 'CHANNEL_DOWN':
          dispatch(channelDown());
          break;
        case 'LEFT':
          focusRef.current !== Focus.MODAL_LANGUAGE_AUDIO &&
            dispatch(popFocus());
          break;
        case 'RIGHT':
          focusRef.current !== Focus.MODAL_LANGUAGE_SUBTITLES &&
            dispatch(pushFocus(Focus.MODAL_LANGUAGE_SUBTITLES));
          break;
      }
    },
    keyUpHandler: (key) => {
      switch (key) {
        case 'BACK':
          dispatch(clearModal());
          break;
      }
    },
  });

  // Effect hooks

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_LANGUAGE_AUDIO));
    return () => {
      dispatch(filterFocus(Focus.MODAL_LANGUAGE_AUDIO));
      dispatch(filterFocus(Focus.MODAL_LANGUAGE_SUBTITLES));
      dispatch(popFocus());
    };
  }, []);

  return (
    <>
      <Container>
        <Icon />
        <Audio />
        <Subtitles />
      </Container>
    </>
  );
}

export default PlayerLanguageModal;
